import { createRef } from "react";
import { ApplicationLayout } from "melco-ui";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop, useCurrentUser } from "melco-shared-logic";
import { useAppRoles } from "./hooks/roles/useAppRoles";

import { MainContent } from "./MainContent";
import { ErrorBoundary } from "react-error-boundary";
import { ApplicationErrorBoundary } from "./components/errorboundary/ApplicationErrorBoundary";
import { ControlCenterMainNavigation } from "./components/navigation/ControlCenterMainNavigation";
import { MyRolesContext } from "./hooks/roles/useRolesContext";
import { ControlCenterSecondaryNavigation } from "./components/navigation/ControlCenterSecondaryNavigation";
import { useAppDomain } from "./hooks/appdomain/useAppDomain";

function ErrorFallback() {
  return <ApplicationErrorBoundary />;
}

export const Main: React.FC = () => {
  const currentUser = useCurrentUser();
  //console.log(JSON.stringify(currentUser))
  const { roles } = useAppRoles(currentUser?.permissions ?? [])
  //console.log(productVariant)
  const contentAreaRef = createRef<HTMLDivElement>();
  const { footertext } = useAppDomain();

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      {/* <MyAppSettingsContext.Provider value={{ appSettingsResponse }} > */}
      <MyRolesContext.Provider value={{ roles }}>
        <BrowserRouter>
          <ScrollToTop contentAreaRef={contentAreaRef} />
          <ApplicationLayout
            mainNavigation={<ControlCenterMainNavigation />}
            footer={footertext}
            contentAreaRef={contentAreaRef}
          >
            <MainContent />
            <ControlCenterSecondaryNavigation />
          </ApplicationLayout>
        </BrowserRouter>
      </MyRolesContext.Provider>
      {/* </MyAppSettingsContext.Provider> */}
    </ErrorBoundary>
  );
  //    }



  // TODO: Display loading indicator
  // return null;
};
